import { EquipmentFlow } from '../schemas/Exicution/exicution.schema';
import { BOBTAIL } from '../utils/constants';

export type StopActivityProps = {
  id: string;
  stopId: string;
  seqNo: string;
  execActivity: string;
  tmsActivity: string;
  equipmentId: string;
  equipmentType: string;
  equipmentOwner: string;
  equipmentFlow: EquipmentFlow;
  name: string;
};

export const defaultStopActivity: StopActivityProps = {
  equipmentFlow: EquipmentFlow.NA,
  equipmentId: '',
  equipmentOwner: '',
  equipmentType: '',
  execActivity: '',
  id: '',
  name: '',
  seqNo: '',
  stopId: '',
  tmsActivity: '',
};

export const stopActivityProps = {
  id: true,
  stopId: true,
  seqNo: true,
  execActivity: true,
  tmsActivity: true,
  equipmentId: true,
  equipmentType: true,
  equipmentOwner: true,
  equipmentFlow: true,
  name: true,
};

export const getStopActivity = (
  stopActivity: StopActivityProps[] = [],
  isLoadPosting = false,
  stopType?: string
): string => {
  let activity: any[] = stopActivity || [];
  activity = activity.filter(
    (item: StopActivityProps) => (item.tmsActivity || '').toUpperCase() !== BOBTAIL
  );
  if (isLoadPosting) {
    activity = getActivityDetails(stopType, activity);
  } else {
    activity = activity
      .slice()
      .sort((activity1: StopActivityProps, activity2: StopActivityProps) => {
        return Number(activity1.seqNo) - Number(activity2.seqNo);
      });
  }

  const activityNames: string[] = [];

  activity.forEach((item: any) => {
    if (
      !activityNames.includes(
        (item.tmsActivity || item.specialServiceDesc || '').trim()
      )
    ) {
      activityNames.push(item.tmsActivity || item.specialServiceDesc);
    }
  });

  return activityNames.map((item: string) => item).join(', ') || '';
};
const getActivityDetails=(stopType: string | undefined, activity: any[])=> {
  if (stopType === 'P') {
    activity = activity.slice().sort(activity1 => {
      const activityName = activity1.specialServiceDesc && activity1.specialServiceDesc
        .replace(/ /g, '')
        .toUpperCase()
        .slice(0, 9);
      if (activityName === 'DROPEMPTY') {
        return -1;
      } else {
        return 1;
      }
    });
  } else if (stopType === 'D') {
    activity = activity.slice().sort(activity1 => {
      const activityName = activity1.specialServiceDesc && activity1.specialServiceDesc
        .replace(/ /g, '')
        .toUpperCase()
        .slice(0, 11);
      if (activityName === 'PICKUPEMPTY') {
        return 1;
      } else {
        return -1;
      }
    });
  }
  return activity;
}

